import { Injectable } from '@angular/core';
import { StorageService } from '@services/storage/storage.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // CRED: "designer@alkhafeef.com.sa ,Alkhafeef@971836 , 654321",
  FINGER_PRINT="Basic " + btoa(`${"Alkhafeef"}:${"Alkhafeef@123"}`);
  API_KEY= "123456";

  constructor(
    private _storage: StorageService,
  ) {    
   }

  authorization() {
    const token = this._storage.token;    
    const auth = {
      'Authorization': token ? 'Bearer ' + token : this.FINGER_PRINT,
      "api_key": this.API_KEY,
      "platform": '' + this._storage.deviceDetail(3),
      "timezone": '' + this._storage.deviceDetail(4),
      "language": 'en',
      // 'Content-Type': "application/json",
      'Access-Control-Allow-Origin': '*',
    }    
    return auth;
  }

}
